// 切换index.vue页中的顶部导航栏
export const CHANGE_NAVINDEX = "changeNavIndex";
